import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { LoginRedirectComponent } from './login-redirect/login-redirect.component';
import { LogoutRedirectComponent } from './logout-redirect/logout-redirect.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { TwoFactorFormComponent } from './shared/two-factor-form/two-factor-form.component';
import { LockedComponent } from './locked/locked.component';
import { AccountHoldComponent } from './account-hold/account-hold.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ComponentsModule } from 'material-library/dist/components';
import { UserInviteConsentComponent } from './user-invite-consent/user-invite-consent.component';
import { InvitePasswordComponent } from './invite-password/invite-password.component';
import { ResetPasswordService } from '../core/resetpassword.service';
import { SettingsModule } from '../settings/settings.module';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { RegisterComponent } from './register/register.component';
import { ProvisionComponent } from './provision/provision.component';
import { SsoComponent } from './sso/sso.component';
import { EmailChangeVerifyComponent } from './email-change-verify/email-change-verify.component';
import { CancelSubscriptionComponent } from './cancel-subscription/cancel-subscription.component';

@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent,
    LoginRedirectComponent,
    LogoutRedirectComponent,
    ForgotPasswordComponent,
    TwoFactorFormComponent,
    LockedComponent,
    AccountHoldComponent,
    ResetPasswordComponent,
    UserInviteConsentComponent,
    InvitePasswordComponent,
    VerifyEmailComponent,
    RegisterComponent,
    ProvisionComponent,
    SsoComponent,
    EmailChangeVerifyComponent,
    CancelSubscriptionComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ComponentsModule,
    SettingsModule,
    SharedModule,
  ],
  providers: [
    ResetPasswordService,
  ]
})
export class AuthModule { }
